import { useState, useMemo } from 'react';

export default function TemplateLibraryModal({
  onClose,
  onSelectTemplate,
  onCreateBlank,
  templates,
}) {
  const [search, setSearch] = useState('');

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    return templates.filter((t) => t.title.toLowerCase().includes(q));
  }, [search, templates]);

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center backdrop-blur-sm p-3">
      <div className="bg-white w-full max-w-6xl h-[85vh] rounded-2xl shadow-xl flex flex-col overflow-hidden">
        {/* HEADER */}
        <div className="sticky top-0 z-10 bg-white border-b px-5 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div>
            <h2 className="text-lg font-semibold text-gray-800">
              Choose Contract
            </h2>
            <p className="text-xs text-gray-500">
              {filtered.length} contracts available
            </p>
          </div>

          <div className="flex gap-2 w-full md:w-auto">
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search contracts..."
              className="w-full md:w-72 border rounded-lg px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
            />
            <button
              onClick={onClose}
              className="px-3 py-2 text-gray-500 hover:text-black"
            >
              ✕
            </button>
          </div>
        </div>

        {/* LIST */}
        <div className="flex-1 overflow-y-auto px-3 py-4">
          {filtered.length === 0 ? (
            <div className="text-center text-gray-400 mt-10">
              No contracts found
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {filtered.map((t) => (
                <div
                  key={t.id}
                  className="group border rounded-xl p-4 bg-white hover:shadow-md hover:border-blue-200 transition cursor-pointer"
                >
                  {/* ICON + TITLE */}
                  <div className="flex items-start justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center text-[#375AE7] text-lg">
                        📄
                      </div>

                      <div>
                        <div className="font-medium text-sm text-gray-800">
                          {t.title}
                        </div>
                        <div className="text-xs text-gray-400">{t.type}</div>
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2 mt-2">
                    <span className="text-[10px] px-2 py-0.5 bg-orange-100 text-orange-600 rounded">
                      Select a contract and assign to your customer(s)
                    </span>
                  </div>
                  {/* ACTION */}
                  <div className="mt-3 flex justify-end">
                    <button
                      onClick={() => onSelectTemplate(t)}
                      className="opacity-0 group-hover:opacity-100 transition px-3 py-1.5 text-xs bg-[#375AE7] text-white rounded-md"
                    >
                      Use Contract
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* FOOTER */}
        <div className="border-t px-4 py-2 text-xs text-gray-500">
          Scroll to explore contracts • {filtered.length} results
        </div>
      </div>
    </div>
  );
}
